import Vuex from 'vuex'
import journeyBuilder from './modules/journeyBuilder'
import Vue from "vue";

//Vue.use(Vuex) needs to be invoked prior to store creation
Vue.use(Vuex);

export default new Vuex.Store({
    /*
        //https://vuex.vuejs.org/guide/strict.html
        "Do not enable strict mode when deploying for production! 
        Strict mode runs a synchronous deep watcher on the state tree for detecting inappropriate mutations, 
        and it can be quite expensive when you make large amount of mutations to the state. 
        Make sure to turn it off in production to avoid the performance cost."
     */
    strict: process.env.NODE_ENV !== 'production',

    modules: {
        journeyBuilder
    }
})